// extracted by mini-css-extract-plugin
module.exports = {"Title":"NavbarTitle_Title__1uAAB","TitleSmall":"NavbarTitle_TitleSmall__2cJtl","TitleSubTitle":"NavbarTitle_TitleSubTitle__3S77a"};